import React from 'react';
import PropTypes from 'prop-types';
import AttendanceTable from './AttendanceTable';
import attendanceTrackerQuery from './attendanceTrackerQuery.graphql';
import style from './style.css';

const LogTable = props => {
    const { title, description, show } = props.settings;
    const { convertDataStructure } = props;
    const totalSessions = props.totalSessions ? props.totalSessions : 5;

    return (
        <>
            {show && (
                <div className={style.wrapper}>
                    <div>
                        <span style={{ fontWeight: 'bold', fontSize: '1.5em' }}>{title}</span>
                    </div>
                    <div style={{ marginBottom: '0.5em' }}>{description}</div>
                    <AttendanceTable
                        totalSessions={totalSessions}
                        query={props.query ? props.query : attendanceTrackerQuery}
                        convertDataStructure={convertDataStructure}
                        colors={props.settings.colors}
                        filters={props.filters}
                    />
                </div>
            )}
        </>
    );
};

LogTable.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
};

LogTable.defaultProps = {
    filters: {},
};

export default LogTable;
